import { kindFromName, uid } from "./utils.js";

const DB_NAME = "docforge";
const STORE = "files";
const LS_KEY = "docforge:meta";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error("无法打开本地数据库"));
  });
}

function tx(db, mode, fn) {
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    let result;
    try {
      result = fn(store);
    } catch (err) {
      reject(err);
      return;
    }
    t.oncomplete = () => resolve(result && result.result !== undefined ? result.result : result);
    t.onerror = () => reject(t.error || new Error("数据库操作失败"));
    t.onabort = () => reject(t.error || new Error("数据库操作已取消"));
  });
}

export function getMetas() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "[]");
  } catch {
    return [];
  }
}

function putMeta(meta) {
  const metas = getMetas().filter((m) => m.id !== meta.id);
  metas.unshift(meta);
  localStorage.setItem(LS_KEY, JSON.stringify(metas));
}

export async function saveRecord(file, existingMeta) {
  const id = existingMeta?.id || uid();
  const now = Date.now();
  const meta = {
    id,
    name: file.name || existingMeta?.name || "未命名文件",
    kind: existingMeta?.kind || kindFromName(file.name),
    size: file.size || 0,
    type: file.type || "",
    addedAt: existingMeta?.addedAt || now,
    updatedAt: now,
  };
  const db = await openDb();
  await tx(db, "readwrite", (store) => store.put({ id, blob: file }));
  putMeta(meta);
  return meta;
}

export async function getRecord(id) {
  const db = await openDb();
  const row = await tx(db, "readonly", (store) => store.get(id));
  if (!row?.blob) return null;
  const meta = getMetas().find((m) => m.id === id) || {};
  return { ...meta, blob: row.blob };
}

export async function deleteRecord(id) {
  const db = await openDb();
  await tx(db, "readwrite", (store) => store.delete(id));
  const metas = getMetas().filter((m) => m.id !== id);
  localStorage.setItem(LS_KEY, JSON.stringify(metas));
}
